module.exports = __webpack_public_path__ + "static/img/AvonLogoOk.a87840a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/AvonLogoOk.jpg
// module id = 228
// module chunks = 6